import React from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowRight, MapPin, Phone, UserRound, Zap, Lightbulb, Cable, Fan, Plug } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { SHOP, bn } from "../lib/format";
import { CircuitBg, Logo3D } from "../components/Electric";
import InstallApp from "../components/InstallApp";

const GALLERY = [
  { label: "লাইট / বাল্ব", Icon: Lightbulb },
  { label: "তার / ক্যাবল", Icon: Cable },
  { label: "ফ্যান", Icon: Fan },
  { label: "সুইচ / সকেট", Icon: Plug },
];

export default function Welcome() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#0A1633] text-white grid place-items-center px-5 py-12" data-testid="welcome-page">
      <CircuitBg />
      <div className="relative z-10 w-full max-w-2xl text-center flex flex-col items-center fade-up">
        <Logo3D />
        <p className="text-emerald-300 font-semibold tracking-wide mt-4">স্বাগতম</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mt-1" data-testid="welcome-shop-name">{SHOP.name}</h1>
        <p className="text-blue-100/85 mt-3 text-base md:text-lg max-w-md">দোকানের ডিজিটাল হিসাব — মেমো, বাকি, আদায়, স্টক আর ক্রয় এক জায়গায়।</p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/login" data-testid="welcome-enter-button"
            className="group inline-flex items-center gap-2 h-12 px-7 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-white font-semibold text-lg shadow-lg shadow-emerald-500/30 transition-all active:scale-95">
            প্রবেশ করুন <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <InstallApp variant="welcome" />
        </div>

        <div className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-3 w-full max-w-2xl" data-testid="welcome-gallery">
          {GALLERY.map(({ label, Icon }) => (
            <div key={label} className="group flex flex-col items-center gap-2 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl py-4 hover:bg-white/10 hover:-translate-y-0.5 transition-all duration-300">
              <span className="w-12 h-12 rounded-xl grid place-items-center bg-emerald-500/15 text-emerald-300 group-hover:bg-emerald-500/25 group-hover:scale-110 transition-all"><Icon size={24} /></span>
              <span className="text-sm font-semibold text-white">{label}</span>
            </div>
          ))}
        </div>

        <div className="mt-7 flex flex-wrap gap-2 justify-center text-sm text-blue-100/80">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 border border-white/15 px-3 py-1"><MapPin size={14} /> {SHOP.address}</span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 border border-white/15 px-3 py-1"><UserRound size={14} /> {SHOP.proprietor}</span>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 border border-white/15 px-3 py-1 num"><Phone size={14} /> {bn(SHOP.mobile)}</span>
        </div>
      </div>
    </div>
  );
}
